
export const LOAD_CHANGE_LOG_DATA_IN_PROGRESS = "LOAD_CHANGE_LOG_DATA_IN_PROGRESS";
export const loadChangeLogDataInProgress = () => ({
  type: LOAD_CHANGE_LOG_DATA_IN_PROGRESS,
});

export const LOAD_CHANGE_LOG_DATA_SUCCESS = "LOAD_CHANGE_LOG_DATA_SUCCESS";
export const loadChangeLogDataSuccess = (data) => ({
  type: LOAD_CHANGE_LOG_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_CHANGE_LOG_DATA_FAILURE = "LOAD_CHANGE_LOG_DATA_FAILURE";
export const loadChangeLogDataFailure = () => ({
  type: LOAD_CHANGE_LOG_DATA_FAILURE,
});

export const LOAD_CHANGE_LOG_TYPE_LIST_SUCCESS = "LOAD_CHANGE_LOG_TYPE_LIST_SUCCESS";
export const loadChangeLogTypeListSuccess = (data) => ({
  type: LOAD_CHANGE_LOG_TYPE_LIST_SUCCESS,
  payload: { data },
});

export const LOAD_CHANGE_LOG_SUBTYPE_LIST_SUCCESS = "LOAD_CHANGE_LOG_SUBTYPE_LIST_SUCCESS";
export const loadChangeLogSubTypeListSuccess = (data) => ({
  type: LOAD_CHANGE_LOG_SUBTYPE_LIST_SUCCESS,
  payload: { data },
});
